export const ENV = {
  GATHERLANCE_URL: process.env.REACT_APP_GATHERLANCE_URL,
  APP_AWS_S3_PUBLIC_BUCKET: process.env.REACT_APP_AWS_S3_PUBLIC_BUCKET,
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  REACT_APP_STREAM_API_URL: process.env.REACT_APP_STREAM_API_URL,
} as const;
